import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { hasPermission } from '@/hooks/useBackendMenu'
import { estadosV2 } from '@acme/common'
import { Trash2Icon } from 'lucide-react'
import { FeriadosCliente } from 'service/api'

export const columns: (anoAtual: number) => GridColDefPro[] = anoAtual => [
    {
        field: 'uf',
        headerName: 'Estado',
        width: 150,
        valueGetter: params => {
            return estadosV2.find(estado => estado.sigla === params.value)?.nome
        },
    },
    {
        field: 'cidade',
        headerName: 'Cidade',
        width: 220,
        valueGetter: params => {
            const { Cidade } = params.row as FeriadosCliente
            return Cidade?.cidade
        },
    },
    {
        field: 'nome',
        headerName: 'Feriado',
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'dia',
        headerName: 'Data',
        width: 110,
        type: 'date',
        valueGetter: params => {
            const { dia, mes, ano } = params.row as FeriadosCliente
            return `${dia > 9 ? dia : '0' + dia}/${mes > 9 ? mes : '0' + mes}/${
                ano ?? anoAtual
            }`
        },
    },
    {
        field: 'repetir',
        headerName: 'Repetir',
        width: 110,
        type: 'boolean',
        valueGetter: ({ row: { ano } }) => !ano,
        align: 'center',
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) =>
            typeof id === 'string'
                ? null
                : hasPermission(['delete', 'Feriados'], () => (
                      <IconButton href={`${id}/excluir`} title="Excluir">
                          <Trash2Icon className="text-error" />
                      </IconButton>
                  )),
    },
]
